module.exports = __webpack_public_path__ + "static/media/Photo6.a3ca27d8.jpg";